import { Component } from "@angular/core";
import { MenuItem } from "primeng/api";

@Component({
  selector: "uni-doc-manager",
  standalone: false,
  templateUrl: "./doc-manager.component.html",
})
export class DocManagerComponent {
  isSidebarCollapsed = false;

  toggleSidebar(): void {
    this.isSidebarCollapsed = !this.isSidebarCollapsed;
  }

  items: MenuItem[] = [
    {
      label: '<span class="text-l font-bold">Technical Documentation</span>',
      escape: false,
      expanded: true,
      items: [
        {
          label: "Invoice PDF Portal",
          icon: "pi pi-fw pi-file-pdf",
          routerLink: ["/tech-docs/manage/invoice-pdf-portal"],
        },
        {
          label: "QuickBooks Integration",
          icon: "pi pi-fw pi-dollar",
          routerLink: ["/tech-docs/manage/quickbooks-integration"],
        },
        {
          label: "Token Management",
          icon: "pi pi-fw pi-key",
          routerLink: ["/tech-docs/manage/token-management"],
        },
        {
          label: "Scale Integration",
          icon: "pi pi-fw pi-sliders-h",
          routerLink: ["/tech-docs/manage/scale-integration"],
        },
      ],
    },
  ];
}
